import React from 'react'
import { Package } from 'lucide-react'

const Loader = ({ message = 'Загрузка...' }) => {
  return (
    <div className="min-h-screen bg-dark-primary text-white flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          <Package size={64} className="mx-auto text-accent-primary mb-4 animate-pulse" />
          <div className="absolute inset-0 bg-accent-primary/20 rounded-full blur-xl animate-pulse"></div>
        </div>
        <h2 className="text-xl font-semibold text-white mb-2 hidden" >
          {message}
        </h2>
        <div className="flex items-center justify-center gap-1 hidden">
          <div className="w-2 h-2 bg-accent-primary rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-accent-primary rounded-full animate-bounce delay-100"></div>
          <div className="w-2 h-2 bg-accent-primary rounded-full animate-bounce delay-200"></div>
        </div>
      </div>
    </div>
  )
}

export default Loader
